// action types
export const SAVE_PAYMENT_CONFIG = "savePaymentConfig";
export const CLEAR_PAYMENT_CONFIG = "clearPaymentConfig";
export const SAVE_TRANSACTION_ERROR = "saveTransactionError";
export const CLEAR_TRANSACTION_ERROR = "clearTransactionError";
export const SET_COMING_FROM_RECEIPT_PAGE_TO_FALSE =
  "setComingFromReceiptPageToFalse";

// mutation types
export const SET_PAYMENTCONFIG = "setPaymentConfig";
export const PURGE_PAYMENTCONFIG = "purgePaymentConfig";
export const SET_TRANSACTION_ERROR = "setTransactionError";
export const PURGE_TRANSACTION_ERROR = "purgeTransactionError";
export const PURGE_COMING_FROM_RECEIPT_PAGE = "purgeComingFromReceiptPage";

const state = {
  isPaymentConfigSet: false,
  fromReceiptPage: false,
  paymentConfig: {
    merchantId: null,
    returnToMerchantUrl: null,
    intentId: null,
    amount: null,
    currencyCode: null,
    orderNumber: null,
    orderInformation: null
  },
  paymentError: null
};

const getters = {
  paymentConfig(state) {
    return { ...state.paymentConfig };
  },
  isPaymentConfigSet(state) {
    return state.isPaymentConfigSet;
  },
  transactionError(state) {
    if (!state.paymentError) return null;
    return { ...state.paymentError };
  },
  isComingFromReceiptPage(state) {
    return state.fromReceiptPage;
  }
};

const actions = {
  [SAVE_PAYMENT_CONFIG](context, { paymentConfig, fromReceiptPage }) {
    paymentConfig.fromReceiptPage = !!fromReceiptPage;
    context.commit(SET_PAYMENTCONFIG, paymentConfig);
  },
  [CLEAR_PAYMENT_CONFIG](context) {
    context.commit(PURGE_PAYMENTCONFIG);
  },
  [SAVE_TRANSACTION_ERROR](context, transactionError) {
    context.commit(SET_TRANSACTION_ERROR, transactionError);
  },
  [CLEAR_TRANSACTION_ERROR](context) {
    context.commit(PURGE_TRANSACTION_ERROR);
  },
  [SET_COMING_FROM_RECEIPT_PAGE_TO_FALSE](context) {
    context.commit(PURGE_COMING_FROM_RECEIPT_PAGE);
  }
};

const mutations = {
  [SET_PAYMENTCONFIG](state, paymentConfig) {
    state.isPaymentConfigSet = true;
    state.fromReceiptPage = paymentConfig.fromReceiptPage;
    state.paymentConfig.merchantId = paymentConfig.merchantId;
    state.paymentConfig.returnToMerchantUrl = paymentConfig.returnToMerchantUrl;
    state.paymentConfig.intentId = paymentConfig.intentId;
    state.paymentConfig.amount = paymentConfig.amount;
    state.paymentConfig.currencyCode = paymentConfig.currencyCode;
    state.paymentConfig.orderNumber = paymentConfig.orderNumber;
    state.paymentConfig.orderInformation = {
      ...paymentConfig.orderInformation
    };
  },
  [PURGE_PAYMENTCONFIG](state) {
    state.isPaymentConfigSet = false;
    state.fromReceiptPage = false;
    state.paymentConfig.merchantId = null;
    state.paymentConfig.returnToMerchantUrl = null;
    state.paymentConfig.intentId = null;
    state.paymentConfig.amount = null;
    state.paymentConfig.currencyCode = null;
    state.paymentConfig.orderNumber = null;
    state.paymentConfig.orderInformation = null;
    state.paymentError = null;
  },
  [SET_TRANSACTION_ERROR](state, transactionError) {
    state.paymentError = {
      errorTitle: transactionError.errorTitle,
      errorDescription: transactionError.errorDescription
    };
  },
  [PURGE_TRANSACTION_ERROR](state) {
    state.paymentError = null;
  },
  [PURGE_COMING_FROM_RECEIPT_PAGE](state) {
    state.fromReceiptPage = false;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
